// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__frlAE"};